import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { Seo, breadcrumbJsonLd } from "../../components/Seo";
import { Testimonials } from "../../components/Testimonials";
import { BUSINESS_FR, QC_CITIES } from "../../data/site-fr";

export default function ContactFr() {
  return (
    <div data-testid="contact-fr-page">
      <Seo
        lang="fr-CA"
        title="Nous Joindre | 1st Nations Security — Sécurité 24/7"
        description="Contactez 1st Nations Security pour des services de gardiennage au Québec et au Manitoba. Appelez le +1 807-770-0243 ou écrivez-nous — 24/7."
        path="/francais/contact/"
        jsonLd={[breadcrumbJsonLd([{ name: "Accueil", path: "/francais" }, { name: "Contact", path: "/francais/contact" }])]}
      />
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="text-sm text-gray-500 mb-6" aria-label="Fil d'Ariane">
            <Link to="/francais" className="hover:text-[#FF9100]" data-testid="breadcrumb-fr-accueil">Accueil</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-300">Contact</span>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">
            Contactez <span className="text-[#FF9100]">1st Nations Security</span>
          </h1>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mb-12">
            Pas de formulaire, pas d'attente. Joignez directement notre équipe de répartition par téléphone ou par courriel — nous répondons 24 heures sur 24, 7 jours sur 7.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
            <a href={BUSINESS_FR.phoneHref} data-testid="contact-fr-phone-card" className="group bg-[#14161C] hover:bg-[#1C1F28] border border-[#FF9100]/30 hover:border-[#FF9100] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1">
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4 group-hover:scale-110 transition-transform">
                <Phone className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Appelez-nous — Répartition 24/7</h2>
              <p className="font-heading text-2xl font-bold text-[#FF9100] mb-2">{BUSINESS_FR.phone}</p>
              <p className="text-sm text-gray-400">La réponse la plus rapide pour les besoins urgents, la ronde incendie et la réponse aux alarmes.</p>
            </a>

            <a href={BUSINESS_FR.emailHref} data-testid="contact-fr-email-card" className="group bg-[#14161C] hover:bg-[#1C1F28] border border-[#FF9100]/30 hover:border-[#FF9100] rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1">
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4 group-hover:scale-110 transition-transform">
                <Mail className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Écrivez à Notre Équipe</h2>
              <p className="text-lg font-semibold text-[#FF9100] mb-2 break-all">{BUSINESS_FR.email}</p>
              <p className="text-sm text-gray-400">Idéal pour les soumissions, les contrats et les exigences détaillées — indiquez votre ville et vos besoins de couverture.</p>
            </a>

            <div className="bg-[#14161C] border border-white/8 rounded-2xl p-8" data-testid="contact-fr-hours-card">
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4">
                <Clock className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Heures d'ouverture</h2>
              <p className="text-gray-300 mb-1">24 heures sur 24, 7 jours sur 7</p>
              <p className="text-sm text-gray-400">Y compris les fins de semaine et les jours fériés — la sécurité ne dort jamais, nous non plus.</p>
            </div>

            <div className="bg-[#14161C] border border-white/8 rounded-2xl p-8" data-testid="contact-fr-area-card">
              <div className="w-12 h-12 rounded-xl bg-[#FF9100]/10 border border-[#FF9100]/25 flex items-center justify-center text-[#FF9100] mb-4">
                <MapPin className="w-6 h-6" />
              </div>
              <h2 className="font-heading text-xl font-semibold text-white mb-2">Zone de service</h2>
              <p className="text-gray-300 mb-1">Québec et Manitoba, Canada</p>
              <p className="text-sm text-gray-400">Montréal, Laval, Québec, Gatineau, Winnipeg, Brandon et communautés partout en province.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#0A0B0E]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white mb-6">Nous Desservons Votre Ville</h2>
          <div className="flex flex-wrap gap-2">
            {QC_CITIES.map((c) => (
              <Link key={c.slug} to={`/francais/villes/${c.slug}`} data-testid={`contact-fr-ville-${c.slug}`} className="text-xs text-gray-400 hover:text-[#FF9100] border border-white/10 hover:border-[#FF9100]/40 rounded-full px-3 py-1.5 transition-colors">
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Testimonials fr />
    </div>
  );
}
